import React from 'react'
import RecordSection from './_RecordSection'
import InfoLine from './_InfoLine'

const PastMedicalHistory = ({ epcr }) => (
  <RecordSection title="Past Medical History">
    <InfoLine
      label="Conditions"
      value={epcr.pmhx.diseases.map((x) => x.disease).join(', ')}
    />
    <InfoLine label="Allergies" value={epcr.pmhx.allergies.join(', ')} />
    <InfoLine label="Medications" value={epcr.pmhx.medicines.join(', ')} />
    <InfoLine label="Social History" value={epcr.pmhx.socialHx} />
    <InfoLine label="Family History" value={epcr.pmhx.familyHx} />
  </RecordSection>
)

export default PastMedicalHistory
